import React from "react";
import NotificationListPage from "../../components/call-center/NotificationListPage";

const CallCenterPaymentRemindersPage = () => (
  <NotificationListPage
    notificationType="PAYMENT_ALERT"
    titleKey="ccNotificationsRemindersSection"
    emptyMessageKey="ccNotificationsRemindersEmpty"
    fallbackTitleKey="ccNotificationsPaymentAlertTitle"
  />
);

export default CallCenterPaymentRemindersPage;
